import {
    SOCKETS_CONNECTING,
    SOCKETS_ERR, UPDATE_USERS_NOTIFICATION_NEW,
} from '../constants';

const initialState = {
    conn: null,
    error: "",
    message: null
};

export default function websocket(state = initialState, action) {
    switch (action.type) {
        case SOCKETS_CONNECTING:
            return Object.assign({}, state, {
                conn: action.conn,
            });
        case SOCKETS_ERR:
            return Object.assign({}, state, {
                error: action.error.msg,
            });
        case UPDATE_USERS_NOTIFICATION_NEW:
            return {
                ...state,
                message: action.message
            };
        default:
            return state;
    }
}
